var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('div',{style:({ width : _vm.width + 'px'})},[_c('img',{staticClass:"cell-image",style:({ width: _vm.width / 2 + 'px', height: _vm.width / 2 + 'px' }),attrs:{"src":_vm.value[_vm.user.image]}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }